import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface DiagnosticHypothesisSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const DiagnosticHypothesisSection = ({
  formData,
  onFieldChange,
}: DiagnosticHypothesisSectionProps) => {
  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Hipótese diagnóstica
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Indicação de acidente</InputLabel>
            <Select
              name="indicacaoAcidente"
              value={formData.indicacaoAcidente}
              label="Indicação de acidente"
              onChange={handleSelectChange}
            >
              <MenuItem value="0">0 - Trabalho</MenuItem>
              <MenuItem value="1">1 - Trânsito</MenuItem>
              <MenuItem value="2">2 - Outros</MenuItem>
              <MenuItem value="9">9 - Não Acidente</MenuItem>
            </Select>
            <FormHelperText>
              Indicação de acidente ou doença relacionada
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};
